<template>
    <div :style="{ width: width }">
        <div class="row">
            <div class="col-md-5">
                <label for="allOptions">{{ allOptionsLabel }}</label>
                <div class="input-group">
                    <input
                        type="search"
                        v-model="allOptionsSearch"
                        class="form-control"
                        :placeholder="`${$t('Search')}...`"
                        autocomplete="off"
                        name="allOptionsInput"
                        id="allOptionsInput"
                    />
                </div>
                <ul class="form-control scrollable-list">
                    <slot name="originalOptions" :options="filteredOriginalOptions" :selectOption="selectOption">
                        <li v-for="option in filteredOriginalOptions" :key="option[idIndex]" @click="selectOption(option)">
                            <span v-html="option[nameIndex]"></span>
                        </li>
                    </slot>
                </ul>
            </div>

            <div class="col-md-2">
                <div class="d-flex flex-column justify-content-center align-items-center h-100">
                    <span href="javascript:void(0)" class="mb-2 move-button" @click="deselectAllOptions()">
                        <a href="javascript:void(0);"><i class="bi bi-arrow-left"></i></a>
                    </span>
                    <span href="javascript:void(0)" class="move-button" @click="selectAllOptions()">
                        <a href="javascript:void(0);"><i class="bi bi-arrow-right"></i></a>
                    </span>
                </div>
            </div>

            <div class="col-md-5">
                <label for="selectedOptions">{{ selectedOptionsLabel }}</label>
                <div class="input-group">
                    <input
                        type="search"
                        v-model="selectedOptionsSearch"
                        class="form-control"
                        :placeholder="`${$t('Search')}...`"
                        autocomplete="off"
                        name="selectedOptionsInput"
                        id="selectedOptionsInput"
                    />
                </div>
                <ul class="form-control scrollable-list">
                    <slot name="selectedOptions" :options="filteredSelectedOptions" :deselectOption="deselectOption">
                        <li v-for="option in filteredSelectedOptions" :key="option[idIndex]" @click="deselectOption(option)">
                            <span v-html="option[nameIndex]"></span>
                        </li>
                    </slot>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup>
import {ref, watch, onMounted, computed, watchEffect} from 'vue';
const emit = defineEmits(['selectedValuesUpdated']);
// Please do not use $t within defineProps. It breaks functionality.
const props = defineProps({
    width: {
        type: String,
        default: '100%',
    },
    allOptionsLabel: {
        type: String,
        default: 'All Options',
    },
    selectedOptionsLabel: {
        type: String,
        default: 'Selected Options',
    },
    nameIndex: {
        type: String,
        default: 'label',
    },
    idIndex: {
        type: String,
        default: 'id',
    },
    allOptions: {
        type: Object,
        default: () => [],
    },
    selectedOptions: {
        type: Array,
        default: () => [],
    },
    disabledOptions: {
        type: Array,
        default: () => [],
    },
});


const allOptionsSearch = ref('');
const selectedOptionsSearch = ref('');
const modifiedSelectedOptions = ref(props.selectedOptions);

const filteredOriginalOptions = ref([]);
const filteredSelectedOptions = ref(props.selectedOptions);

const allOptions = computed(() => {
    return  props.allOptions?.filter(option => !modifiedSelectedOptions.value.map(selectedOption => selectedOption[props.idIndex]).includes(option[props.idIndex]));
});

watchEffect(() => {
    if (allOptionsSearch.value === '') {
        filteredOriginalOptions.value = allOptions.value;
    } else {
        filteredOriginalOptions.value = allOptions.value.filter((option) =>
            option[props.nameIndex].toLowerCase().includes(allOptionsSearch.value.trim().toLowerCase())
        );
    }
});

watchEffect(() => {
    if (selectedOptionsSearch.value === '') {
        filteredSelectedOptions.value = modifiedSelectedOptions.value;
    } else {
        filteredSelectedOptions.value = modifiedSelectedOptions.value.filter((option) =>
            option[props.nameIndex].toLowerCase().includes(selectedOptionsSearch.value.trim().toLowerCase())
        );
    }
});

watch(
    () => props.selectedOptions,
    (newVal, oldVal) => {
        modifiedSelectedOptions.value = newVal;
    }
);

const selectOption = (option) => {
    // if (!modifiedSelectedOptions.value.includes(option)) {
    //     modifiedSelectedOptions.value.push(option);
    // }
    if (props.disabledOptions.filter(disabledOption => disabledOption[props.idIndex] === option[props.idIndex]).length) {
        return;
    }
    if (!modifiedSelectedOptions.value.some(item => item[props.idIndex] === option[props.idIndex])) {
        modifiedSelectedOptions.value.push(option);
    }
};

const selectAllOptions = () => {
    filteredOriginalOptions.value.forEach(itemMain => {
        if (props.disabledOptions.filter(disabledOption => disabledOption[props.idIndex] === itemMain[props.idIndex]).length) {
            return;
        }
        if (!modifiedSelectedOptions.value.some(item => item[props.idIndex] === itemMain[props.idIndex])) {
            modifiedSelectedOptions.value.push(itemMain);
        }
    });
}
const deselectOption = (option) => {
    if (props.disabledOptions.filter(disabledOption => disabledOption[props.idIndex] === option[props.idIndex]).length) {
        return;
    }
    modifiedSelectedOptions.value = modifiedSelectedOptions.value.filter((item) => item[props.idIndex] !== option[props.idIndex]);
};

const deselectAllOptions = () => {
    if (selectedOptionsSearch.value !== '') {
        filteredSelectedOptions.value.forEach(itemMain => {
            if (props.disabledOptions.filter(disabledOption => disabledOption[props.idIndex] === itemMain[props.idIndex]).length) {
                return;
            }
            const itemIndex = modifiedSelectedOptions.value.findIndex(item => item[props.idIndex] === itemMain[props.idIndex]);
            if (itemIndex !== -1) {
                modifiedSelectedOptions.value.splice(itemIndex, 1);
            }
        });
    }else{
        modifiedSelectedOptions.value = [];
    }

};

watchEffect(() => {
    emit('selectedValuesUpdated', modifiedSelectedOptions.value);
});

</script>
<style>
.scrollable-list {
    list-style-type: none;
    min-height: 200px;
    max-height: 200px;
    overflow-y: auto;
    border-radius: 8px;
    border: 1px solid #a3b9c9;
    padding: 0;
}

.scrollable-list li {
    cursor: pointer;
    padding: 8px;
}

.scrollable-list li:hover {
    background-color: #f0f5f9;
}

.input-group {
    position: relative;
}

.input-group .form-control {
    padding-right: 40px;
}

.input-group .form-control::before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    width: 100%;
    height: 100%;
    border-radius: 8px 8px 0 0;
    border: 1px solid #a3b9c9;
}

.input-group .form-control::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: -1px;
    width: 100%;
    height: 100%;
    border-radius: 0 0 8px 8px;
    border: 1px solid #a3b9c9;
}
</style>
